import {track} from "@otto-ec/nav_star-track";

export class ShortcutCategories extends HTMLElement {
    static get customElement() {
        return "nav_shortcut-categories";
    }

    scrolled = false;

    constructor() {
        super();
    }

    connectedCallback() {
        Array.from(this.querySelectorAll('oc-media-object-card-v1,oc-card-v2 a[data-nav-track=true]'))
            .forEach(entry => {
                entry.addEventListener('click', event => {
                    track(event.target, "user-action/visit-shortcut-category-link");
                })
            });

        const cinema = this.querySelector('oc-cinema-v1[data-nav-track=true]');
        cinema.addEventListener("oc-stage-scroll-completed", () => {
            if (!this.scrolled) {
                track(cinema, "user-action/first-slider-scroll");
                this.scrolled = true;
            }
        });
    }
}